import Form from './block/form/browser';
import QuestionTypes from './question-types/browser';

const Blocks = {
	'form': Form
};

export { Blocks, QuestionTypes };

